import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Form } from "reactstrap";
import { useForm } from "react-hook-form";
import useLogout from "../../hooks/useLogout";
import MyInput from "../../MyComp/UI/form/MyInput";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyNumber from "../../MyComp/UI/form/MyNumber";
import { createReferralAPI, deleteReferralAPI, listReferralAPI, updateReferralAPI } from "../../api/referral";
import { toast } from "react-toastify";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";

const ManageReferral = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      loading: false,
      data: [],
      disease_image: null,
      disease_img: null,
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const loading = watch("loading");
  const data = watch("data");
  const [column, setColumn] = useState([
    {
      name: "Like",
      selector: (row) => row?.like,
      sortable: true,
    },
    {
      name: "Share",
      selector: (row) => row?.share,
      sortable: true,
    },
    {
      name: "Prakrati Parikshan",
      selector: (row) => row?.prakrati_bonus,
      sortable: true,
    },
    {
      name: "Immunity Assessment",
      selector: (row) => row?.immunity_bonus,
      sortable: true,
    },
    {
      name: "New Register Bonus",
      selector: (row) => row?.new_register,
      sortable: true,
    },
    {
      name: "Referrer",
      selector: (row) => row?.referrer_bonus,
      sortable: true,
    },
    {
      name: "Referee",
      selector: (row) => row?.referee_bonus,
      sortable: true,
    },

    {
      name: "Action",
      wrap: true,
      width: "220px",
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>
          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
              {" "}
              <Icon name="trash"></Icon>
            </Button> */}
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getReferralList();
  }, []);
  const getReferralList = () => {
    setValue("loading", true);
    listReferralAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("data", res.data.data);
          setValue("loading", false);
        } else if (res.data.status === false) {
          setValue("loading", false);
          setValue("data", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("loading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("loading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onFormSubmit = (data) => {
    const body = {
      like: watch("like"),
      share: watch("share"),
      prakrati_bonus: watch("prakrati_bonus"),
      immunity_bonus: watch("immunity_bonus"),
      new_register: watch("new_register"),
      referrer: watch("referrer"),
      referee: watch("referee"),
      ...(mode == "Edit" && { id: watch("selectedRow")?.id }),
    };
    if (mode == "Add") {
      createReferralAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getReferralList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateReferralAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getReferralList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };

  const handleEdit = (row) => {
    setMode("Edit");
    setValue("selectedRow", row);
    setValue("like", row.like);
    setValue("share", row.share);
    setValue("referrer", row.referrer_bonus);
    setValue("referee", row.referee_bonus);
    setValue("new_register", row.new_register);
    setValue("immunity_bonus", row.immunity_bonus);
    setValue("prakrati_bonus", row.prakrati_bonus);
    setIsOpen(true);
  };
  const handleDelete = (row) => {
    const body = {
      id: row?.id,
    };
    deleteReferralAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getReferralList();
          setIsOpen(false);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const fReset = () => {};
  return (
    <>
      <Head title="Referral | Referral Management" />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Referral Management"}
              </BlockTitle>
            </BlockHeadContent>
            {data?.length > 0 ? null : (
              <BlockHeadContent>
                <div className="">
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      setIsOpen((pre) => !pre);
                      fReset();
                    }}
                  >
                    <Icon name={isOpen ? "minus" : "plus"} />
                  </Button>
                </div>
              </BlockHeadContent>
            )}
            {mode == "Edit" && (
              <BlockHeadContent>
                <div className="">
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      setIsOpen(false);
                      setMode("Add");
                      fReset();
                    }}
                  >
                    <Icon name={"minus"} />
                  </Button>
                </div>
              </BlockHeadContent>
            )}
          </BlockBetween>
        </BlockHead>
        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="3">
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Like Article/Doctor/Product"}
                      name={"like"}
                      placeholder={"Enter like bonus"}
                      required
                      min={1}
                      max={500}
                    />
                  </Col>
                  <Col md="3">
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Share Article/Doctor/Product On Social Media"}
                      name={"share"}
                      placeholder={"Enter share bonus"}
                      required
                      min={1}
                      max={500}
                    />
                  </Col>
                  <Col md="3">
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"On First Time Prakrati Parikshan"}
                      name={"prakrati_bonus"}
                      placeholder={"Enter prakrati bonus"}
                      required
                      min={1}
                      max={500}
                    />
                  </Col>
                  <Col md="3">
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"On First Time Immunity Assessment"}
                      name={"immunity_bonus"}
                      placeholder={"Enter immunity bonus"}
                      required
                      min={1}
                      max={500}
                    />
                  </Col>
                  <Col md="3">
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"New Register Bonus"}
                      name={"new_register"}
                      placeholder={"Enter registration bonus"}
                      required
                      min={1}
                      max={1000}
                    />
                  </Col>
                  <Col md="3">
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Referrer"}
                      name={"referrer"}
                      placeholder={"Enter referrer bonus"}
                      required
                      min={1}
                      max={500}
                    />
                  </Col>
                  <Col md="3">
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Referee"}
                      name={"referee"}
                      placeholder={"Enter referee bonus"}
                      required
                      min={1}
                      max={500}
                    />
                  </Col>
                </Row>
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data} columns={column} title={"Referral List"} isLoading={loading} />
        </Block>
      </Content>
    </>
  );
};

export default ManageReferral;
